module.exports = __webpack_public_path__ + "img/57.936aa88c.png";